import { buildPageGraph, type PageGraphInput } from './graph'

export interface JsonLdScript {
  type: 'application/ld+json'
  innerHTML: string
  key: string
}

/** A stable head key replaces the graph during client-side navigation. */
export function generatePageJsonLdScripts(input: PageGraphInput): JsonLdScript[] {
  const graph = buildPageGraph(input)
  if (!graph) return []
  return [{
    type: 'application/ld+json',
    // CMS text must not break out of a server-rendered script element.
    innerHTML: JSON.stringify(graph).replace(/</g, '\\u003c').replace(/>/g, '\\u003e').replace(/&/g, '\\u0026'),
    key: 'page-jsonld',
  }]
}
